import type { SVGProps } from "react";

const AboveGroundIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 64 64"
        {...props}
    >
        <path fill="currentColor" d="M60 55h-1V4a1 1 0 0 0-1-1H28a1 1 0 0 0-1 1v11H6a1 1 0 0 0-1 1v39H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1ZM29 5h28v50h-2V8a1 1 0 0 0-1-1H32a1 1 0 0 0-1 1v47h-2Zm4 50V45h9v10Zm0-12v-4h20v4Zm0-10h20v4H33Zm0-6h20v4H33Zm0-6h20v4H33Zm20-2H33v-4h20Zm0-6H33V9h20Zm-9 32h9v10h-9ZM11 55v-4h16v4Zm0-16h16v4H11Zm0-6h16v4H11Zm16-2H11v-4h16ZM11 45h16v4H11Zm16-20H11v-4h16ZM7 17h20v2H10a1 1 0 0 0-1 1v35H7Zm52 42H5v-2h54Z" />
    </svg>
);
export default AboveGroundIcon;

